// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"style_aboutUs__1w7T6","light":"style_light__1dvMd"};